import React, { useGlobal } from "reactn";
import { Link } from "react-router-dom";

import {
  Notification,
  NotificationStatuses,
} from "@jsainsburyplc/id-ui-common";

import { getLoginLink } from "utils/urls";
import PageFormat from "../../PageFormat";

const AccountConfirmationSuccess = () => {
  const [title] = useGlobal("title");
  return (
    <PageFormat>
      <div className="c-hero c-hero--center">
        <h1>{title}</h1>
      </div>
      <div className="ln-u-soft ln-u-text-align-center">
        <Notification type={NotificationStatuses.SUCCESS_TYPE}>
          You have successfully verified your email address.
        </Notification>
        <br />

        <Link
          to={getLoginLink()}
          className="ln-c-button ln-c-button--filled ln-c-button--full"
        >
          Log in
        </Link>
      </div>
    </PageFormat>
  );
};

export default AccountConfirmationSuccess;
